import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zhankai",
  "use": "icon-zhankai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhankai\"><path fill=\"#515151\" d=\"M512 608c-9.6 0-16-3.2-22.4-9.6l-384-384c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0L512 531.2 873.6 169.6c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8l-384 384c-6.4 6.4-12.8 9.6-22.4 9.6z\" /><path fill=\"#515151\" d=\"M512 864c-9.6 0-16-3.2-22.4-9.6l-384-384c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0L512 787.2l361.6-361.6c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8l-384 384c-6.4 6.4-12.8 9.6-22.4 9.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol